import { render, staticRenderFns } from "./FPTableUserProfile.vue?vue&type=template&id=24944f66"
import script from "./FPTableUserProfile.vue?vue&type=script&lang=js"
export * from "./FPTableUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports